var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "106px",
        height: "106px",
        viewBox: "0 0 106 106",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "path-1",
            points: "0 0.0002 60.5897 0.0002 60.5897 36.9069 0 36.9069"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-923.000000, -413.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(923.000000, 413.000000)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M106,90.9548646 C106,99.2637914 99.2146745,106 90.8451633,106 L15.1548367,106 C6.78532554,106 0,99.2637914 0,90.9548646 L0,15.0451354 C0,6.73520562 6.78532554,0 15.1548367,0 L90.8451633,0 C99.2146745,0 106,6.73520562 106,15.0451354 L106,90.9548646 Z",
                      id: "Mask",
                      fill: "#829FCE"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group-3",
                        transform: "translate(23.000000, 35.000000)"
                      }
                    },
                    [
                      _c("mask", { attrs: { id: "mask-2", fill: "white" } }, [
                        _c("use", { attrs: { "xlink:href": "#path-1" } })
                      ]),
                      _vm._v(" "),
                      _c("g", { attrs: { id: "Clip-2" } }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M57.4707,29.1299 C57.4707,29.1859 57.4257,29.2309 57.3707,29.2309 L54.4767,29.2309 C54.4317,29.2309 54.3887,29.2389 54.3437,29.2429 C53.7127,26.4399 51.2067,24.3359 48.2147,24.3359 C45.2457,24.3359 42.7577,26.4079 42.1037,29.1819 L39.2457,29.1819 L39.2407,4.0199 C39.2407,3.9639 39.2847,3.9189 39.3397,3.9189 C43.7907,3.9189 47.1287,5.7159 49.2657,9.2589 L49.4137,9.5649 L46.5097,9.5649 C44.7047,9.5649 43.2887,10.9449 43.2887,12.7079 C43.2887,14.1149 44.2847,15.5349 46.5097,15.5349 L53.8947,15.5359 C55.8667,15.5579 57.4707,17.1899 57.4707,19.1739 L57.4707,29.1299 Z M48.2147,33.7869 C46.4707,33.7869 45.0507,32.3669 45.0507,30.6219 C45.0507,28.8759 46.4707,27.4559 48.2147,27.4559 C49.9607,27.4559 51.3807,28.8759 51.3807,30.6219 C51.3807,32.3669 49.9607,33.7869 48.2147,33.7869 L48.2147,33.7869 Z M31.8227,29.1899 L23.3707,29.1899 L23.3707,11.9429 C23.3707,10.2749 22.0117,8.9179 20.3437,8.9179 L14.7737,8.9179 L14.7737,3.1199 L20.3517,3.1199 C20.4747,4.6779 21.7817,5.9059 23.3667,5.9059 C24.9547,5.9059 26.2617,4.6779 26.3827,3.1199 L31.8227,3.1199 L31.8227,29.1899 Z M20.2497,29.1899 L17.2967,29.1899 C16.6467,26.4119 14.1567,24.3359 11.1817,24.3359 C9.1977,24.3359 7.4397,25.2759 6.2887,26.7209 L6.2887,12.0379 L10.2417,12.0379 L10.2417,12.1429 L10.2437,12.4289 C10.2437,14.0969 11.6017,15.4529 13.2697,15.4529 C14.9377,15.4529 16.2947,14.0969 16.2947,12.4289 L16.2967,12.1409 L16.2967,12.0379 L20.2497,12.0379 L20.2497,29.1899 Z M11.1817,33.7869 C9.4377,33.7869 8.0177,32.3669 8.0177,30.6219 C8.0177,28.8759 9.4377,27.4559 11.1817,27.4559 C12.9277,27.4559 14.3477,28.8759 14.3477,30.6219 C14.3477,32.3669 12.9277,33.7869 11.1817,33.7869 L11.1817,33.7869 Z M54.2887,12.4309 L52.0387,7.8289 L51.9767,7.7169 C49.2817,3.1919 44.9097,0.7989 39.3397,0.7989 C37.5647,0.7989 36.1207,2.2429 36.1207,4.0199 L36.1267,29.1899 L34.9417,29.1899 L34.9417,3.0259 C34.9417,1.3579 33.5857,-0.0001 31.9177,-0.0001 L14.6797,-0.0001 C13.0117,-0.0001 11.6547,1.3579 11.6547,3.0259 L11.6547,8.9179 L6.1957,8.9179 C4.5277,8.9179 3.1697,10.2749 3.1697,11.9429 L3.1697,29.1819 L1.5587,29.1819 C0.6997,29.1819 -0.0003,29.8799 -0.0003,30.7409 C-0.0003,31.6029 0.6997,32.3019 1.5587,32.3019 L5.1327,32.3019 C5.8687,34.9529 8.2987,36.9069 11.1817,36.9069 C14.0627,36.9069 16.4917,34.9569 17.2307,32.3099 L39.2477,32.3099 L39.2477,32.3019 L42.1637,32.3019 C42.9027,34.9529 45.3317,36.9069 48.2147,36.9069 C51.0897,36.9069 53.5137,34.9659 54.2597,32.3279 C54.3317,32.3379 54.4047,32.3509 54.4767,32.3509 L57.3707,32.3509 C59.1467,32.3509 60.5897,30.9049 60.5897,29.1299 L60.5897,19.1739 C60.5897,15.6139 57.8027,12.6639 54.2887,12.4309 L54.2887,12.4309 Z",
                          id: "Fill-1",
                          fill: "#FFFFFF",
                          mask: "url(#mask-2)"
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }